import React from 'react'
import { listCryptoAssetsPaged } from '@/modules/crypto-assets/services/cryptoAssetsService'
import { getPlanAssetPolicyPublic } from '../services/planAssetPolicyService'

export type UsePlanAssetCountResult = {
  count: number | null
  loading: boolean
  error: string | null
}

export function usePlanAssetCount(planId?: string | null): UsePlanAssetCountResult {
  const [count, setCount] = React.useState<number | null>(null)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    let active = true

    async function load() {
      const id = (planId || '').trim()
      if (!id) {
        if (active) {
          setCount(null)
          setLoading(false)
          setError(null)
        }
        return
      }
      if (active) {
        setLoading(true)
        setError(null)
      }
      try {
        const policy = await getPlanAssetPolicyPublic(id)
        if (!active) return
        if (policy?.mode === 'limited') {
          setCount((policy.allowed_symbols || []).length)
          return
        }
        const { total, items } = await listCryptoAssetsPaged({ page: 0, pageSize: 1, onlyActive: true })
        if (!active) return
        const resolved = typeof total === 'number' ? total : (items?.length ?? 0)
        setCount(resolved)
      } catch (e: any) {
        if (!active) return
        setError(e?.message || 'Falha ao carregar quantidade de moedas')
        setCount(null)
      } finally {
        if (active) setLoading(false)
      }
    }

    load()
    return () => { active = false }
  }, [planId])

  return { count, loading, error }
}
